import { setUserAction } from "store/actions/userProfile";

import { getUserDetails } from "api/users";

export default function userFetchUserDetailsHandler(dispatch) {
  const fetchUserDetails = async () => {
    try {
      const response = await getUserDetails();
      if (response && response.data && response.status === 200) {
        const UserName = response.data.Name;
        const NickName = UserName.split(" ")[0];
        dispatch(setUserAction({ UserName, NickName }));
      }
    } catch (err) {}
  };
  return { fetchUserDetails };
}
